import { render, staticRenderFns } from "./params-block.vue?vue&type=template&id=cc28d9fc&scoped=true"
import script from "./params-block.vue?vue&type=script&lang=js"
export * from "./params-block.vue?vue&type=script&lang=js"
import style0 from "./params-block.vue?vue&type=style&index=0&id=cc28d9fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc28d9fc",
  null
  
)

export default component.exports